var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.routeName,attrs:{"id":"app"}},[_c('Header'),_c('transition',{attrs:{"name":"changePage","mode":"out-in"}},[_c('router-view')],1),(!_vm.isFooter)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }